import { render } from "./OverlijdensberichtenLivestream.vue?vue&type=template&id=79cfb6c0"
import script from "./OverlijdensberichtenLivestream.vue?vue&type=script&lang=js"
export * from "./OverlijdensberichtenLivestream.vue?vue&type=script&lang=js"

import "./OverlijdensberichtenLivestream.vue?vue&type=style&index=0&id=79cfb6c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__